import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import {
  selectUserGlobalData,
  reduxSetUploads,
  setUserGlobalData,
} from "../store/dreamworldSlice";
import AppLayout from "../layouts/AppLayout"; // Import the AppLayout component
import dreamWorldProvider from "../DreamWorldProvider";
import { AppDispatch } from "../store/store";
import { LibraryItem } from "../types/library";
import { isDreamLive } from "../utils/isDreamLive";

interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const userGlobalData = useSelector(selectUserGlobalData);
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setLoading] = React.useState(
    userGlobalData?.userData?.uid ? false : true
  );
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUploads = async () => {
      if (userGlobalData) {
        const uploads = await dreamWorldProvider.getUploads(
          userGlobalData.user.uid
        );
        dispatch(reduxSetUploads(uploads as LibraryItem[]));
      }
    };

    fetchUploads();
  }, [userGlobalData, dispatch]);

  useEffect(() => {
    const checkLoginState = async () => {
      const isSignedIn = localStorage.getItem("isSignedIn");
      if (isSignedIn === "true") {
        setLoading(true);
        try {
          let userGlobalData;
          if (isDreamLive()) {
            userGlobalData = await dreamWorldProvider.autoSignInFromSession();
          } else {
            userGlobalData = await dreamWorldProvider.signInWithPi();
          }
          dispatch(setUserGlobalData(userGlobalData));
          await dreamWorldProvider.checkSubscription(userGlobalData.user.uid);
          setLoading(false);
        } catch (error) {
          console.error("Auto sign-in failed", error);
          localStorage.removeItem("isSignedIn");
          navigate("/login");
        } finally {
          setLoading(false);
        }
      } else {
        navigate("/login");
      }
    };
    if (!userGlobalData?.userData?.uid) checkLoginState();
  }, [navigate, dispatch]);

  return isLoading ? (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-indigo-500"></div>
      <p className="text-white ml-4">Loading...</p>
    </div>
  ) : (
    <AppLayout>{children}</AppLayout>
  ); // Wrap children with AppLayout
};

export default AuthRoute;
